import { useSuspenseQuery } from '@tanstack/react-query';
import { CalendarDay } from 'further-ui/utils';
import api, { type ApiResponses } from 'lib/trpcClient';
import { CapitalActionFormValues } from '../../hooks/useCapitalActionForm';

export default function useTransactionTypes({
  capitalActionId,
  entries,
  vehicleId,
  date,
}: {
  capitalActionId?: string;
  entries: CapitalActionFormValues['entries'];
  vehicleId: string;
  date: CalendarDay;
}) {
  const getTransactionTypes =
    api.capitalAction.getTransactionTypes.useMutation();

  const result = useSuspenseQuery<
    ApiResponses['capitalAction']['getTransactionTypes']
  >({
    queryKey: ['transactionTypes', capitalActionId, vehicleId, entries, date],
    queryFn: async () =>
      getTransactionTypes.mutateAsync({
        capitalActionId,
        vehicleId,
        entries,
        date,
      }),
  });

  return result.data;
}
